// Generated by scripts/generate.mjs from docs/protocol/app-v1 - do not edit, run `npm run generate`.
/* eslint-disable */
import type { AppContractConstants, AppEndpointTable, AppReasonCatalog, TasteTagCatalog } from './types.js';

/** contract.json */
export const contract = {
  "version": 1,
  "wsPath": "/ws",
  "pingIntervalMs": 25000,
  "commandTimeoutMs": 10000,
  "maxClientMessageBytes": 16384,
  "closeCodes": {
    "normal": 1000,
    "shutdown": 1001,
    "clientDrop": 4000,
    "unauthorized": 4401,
    "badOrigin": 4403
  },
  "cookies": {
    "session": "__Host-bc_session",
    "loginBinding": "__Host-bc_login",
    "statePrefix": "__Host-bc",
    "insecureDevSession": "bc_session",
    "insecureDevLoginBinding": "bc_login"
  },
  "session": {
    "slidingDays": 30,
    "maxDays": 90,
    "operatorHours": 12,
    "freshLoginMinutes": 15
  },
  "loginCode": {
    "length": 8,
    "ttlSeconds": 900,
    "maxAttempts": 5
  },
  "invitationDays": 14
} as const satisfies AppContractConstants;

/** catalog/reasons.json: reason codes that exist only between app and API */
export const appReasonCatalog: AppReasonCatalog = {
  "reasons": [
    {
      "code": "unauthorized",
      "de": "Nicht angemeldet. Bitte anmelden.",
      "en": "Not signed in. Please sign in.",
      "http": 401
    },
    {
      "code": "bad_origin",
      "de": "Diese Anfrage kam nicht von Brewcore.",
      "en": "This request didn't come from Brewcore.",
      "http": 403
    },
    {
      "code": "unknown_message",
      "de": "Cloud kennt diese Anfrage nicht. Bitte App neu laden.",
      "en": "Cloud doesn't recognise this request. Please reload the app."
    },
    {
      "code": "code_invalid",
      "de": "Code stimmt nicht.",
      "en": "Code isn't right.",
      "http": 400
    },
    {
      "code": "code_expired",
      "de": "Code ist abgelaufen. Bitte neuen anfordern.",
      "en": "Code has expired. Please request a new one.",
      "http": 400
    },
    {
      "code": "not_invited",
      "de": "Diese Adresse ist nicht eingeladen.",
      "en": "This address hasn't been invited.",
      "http": 403
    },
    {
      "code": "email_not_verified",
      "de": "Google hat die Adresse nicht bestätigt. Bitte per Code anmelden.",
      "en": "Google hasn't verified this address. Please sign in with a code.",
      "http": 403
    },
    {
      "code": "account_not_linked",
      "de": "Google ist nicht verknüpft. Bitte per Code anmelden und unter Konto verknüpfen.",
      "en": "Google isn't linked. Please use a code, then link under Account.",
      "http": 409
    },
    {
      "code": "operator_only",
      "de": "Das kann nur der Betreiber.",
      "en": "Only the operator can do this.",
      "http": 403
    },
    {
      "code": "passkey_required",
      "de": "Bitte dafür mit Passkey anmelden.",
      "en": "Please sign in with a passkey first.",
      "http": 403
    },
    {
      "code": "not_configured",
      "de": "Diese Anmeldeart ist nicht eingerichtet.",
      "en": "This sign-in method isn't set up.",
      "http": 404
    },
    {
      "code": "auth_failed",
      "de": "Anmeldung fehlgeschlagen. Bitte gleich noch einmal versuchen.",
      "en": "Sign-in failed. Please try again in a moment.",
      "http": 400
    },
    {
      "code": "claude_no_key",
      "de": "Im Konto ist kein Claude-Schlüssel gespeichert.",
      "en": "There's no Claude key in the account.",
      "http": 409
    },
    {
      "code": "claude_key_invalid",
      "de": "Anthropic hat den Claude-Schlüssel abgelehnt. Bitte neuen eintragen.",
      "en": "Anthropic rejected the Claude key. Please enter a new one.",
      "http": 400
    },
    {
      "code": "claude_credit",
      "de": "API-Guthaben ist aufgebraucht. Bitte bei Anthropic aufladen.",
      "en": "API credit is used up. Please top it up at Anthropic.",
      "http": 402
    },
    {
      "code": "claude_model",
      "de": "Claude-Schlüssel kann dieses Modell nicht nutzen. Bitte ein anderes wählen.",
      "en": "Claude key can't use this model. Please choose another one.",
      "http": 400
    },
    {
      "code": "claude_rate_limited",
      "de": "Claude-Schlüssel ist am Limit. Bitte später noch einmal versuchen.",
      "en": "Claude key is at its limit. Please try again later.",
      "http": 429
    },
    {
      "code": "claude_refused",
      "de": "Claude hat diese Anfrage abgelehnt.",
      "en": "Claude declined this request.",
      "http": 422
    },
    {
      "code": "claude_failed",
      "de": "Keine brauchbare Antwort von Claude. Bitte noch einmal fragen.",
      "en": "No usable answer from Claude. Please ask again.",
      "http": 502
    },
    {
      "code": "claude_unavailable",
      "de": "Claude ist gerade nicht erreichbar. Bitte später noch einmal versuchen.",
      "en": "Claude can't be reached right now. Please try again later.",
      "http": 503
    },
    {
      "code": "rev_conflict",
      "de": "Das wurde anderswo geändert. Bitte App neu laden.",
      "en": "This was changed elsewhere. Please reload the app.",
      "http": 409
    },
    {
      "code": "bean_exists",
      "de": "Bohnenname ist schon vergeben.",
      "en": "Bean name is already taken.",
      "http": 409
    },
    {
      "code": "bean_has_shots",
      "de": "Diese Bohne hat Bezüge. Bitte stattdessen archivieren.",
      "en": "This bean has shots. Please archive it instead.",
      "http": 409
    }
  ]
};

/** catalog/taste-tags.json: the taste tags of a shot (fixed IDs, texts in both languages) */
export const tasteTagCatalog: TasteTagCatalog = {
  "tags": [
    {
      "id": "sweet",
      "de": "süß",
      "en": "sweet"
    },
    {
      "id": "fruity",
      "de": "fruchtig",
      "en": "fruity"
    },
    {
      "id": "chocolate",
      "de": "schokoladig",
      "en": "chocolatey"
    },
    {
      "id": "full",
      "de": "vollmundig",
      "en": "full-bodied"
    },
    {
      "id": "watery",
      "de": "wässrig",
      "en": "watery"
    },
    {
      "id": "dry",
      "de": "trocken",
      "en": "drying",
      "hint": {
        "de": "pelzig im Mund",
        "en": "puckering, like strong tea"
      }
    },
    {
      "id": "channeling",
      "de": "Kanalbildung",
      "en": "channelling",
      "fromMeta": "channeling"
    }
  ]
};

/** endpoints.json */
export const endpointTable: AppEndpointTable = {
  "endpoints": [
    {
      "method": "GET",
      "path": "/api/me",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-me",
        "401": "http-error"
      }
    },
    {
      "method": "GET",
      "path": "/api/machines",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-machines",
        "401": "http-error"
      }
    },
    {
      "method": "GET",
      "path": "/api/auth/session",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-auth-session",
        "401": "http-error"
      },
      "note": "Sliding refresh: renews the cookie when the last refresh is older than a day."
    },
    {
      "method": "GET",
      "path": "/api/auth/providers",
      "auth": "none",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-auth-providers"
      },
      "note": "Public; the login screen asks before it shows the Google button."
    },
    {
      "method": "POST",
      "path": "/api/auth/logout",
      "auth": "none",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "403": "http-error"
      },
      "note": "Ends the current session (if any), expires the cookie and closes its WebSockets."
    },
    {
      "method": "POST",
      "path": "/api/auth/logout-all",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error"
      },
      "note": "Überall abmelden: ends every session of the account and closes all its WebSockets."
    },
    {
      "method": "GET",
      "path": "/api/auth/sessions",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-sessions",
        "401": "http-error"
      }
    },
    {
      "method": "DELETE",
      "path": "/api/auth/sessions/:id",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      }
    },
    {
      "method": "POST",
      "path": "/api/auth/google/start",
      "auth": "none",
      "origin": true,
      "by": "api",
      "request": "http-google-start-request",
      "responses": {
        "200": "http-google-start-response",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "link: true needs a fresh session (fresh_login otherwise)."
    },
    {
      "method": "POST",
      "path": "/api/pairing/lookup",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-pairing-lookup-request",
      "responses": {
        "200": "http-pairing-lookup-response",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "410": "http-error",
        "429": "http-error"
      },
      "note": "Code or QR token (FR-5, FR-6); a wrong code counts as a failed attempt (pairing_invalid), limits per account and IP."
    },
    {
      "method": "POST",
      "path": "/api/pairing/confirm",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-pairing-confirm-request",
      "responses": {
        "200": "http-pairing-confirm-response",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error",
        "410": "http-error",
        "429": "http-error"
      },
      "note": "Creates the coupling (AD-22). continueFrom of a machine that does not share the hardware hint (swapped controller) needs a fresh login: 403 fresh_login."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/unpair",
      "auth": "fresh",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-unpair-response",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "Owner only (owner_only), fresh login (403 fresh_login, FR-48); the coupling ends at once (AD-43)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/heatup",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-heatup-response",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "The learned heat-up time for the weekly plan's ready times (Dominik 21.10.2026). The API measures it: every woken event opens a measurement (cold: cause power, or the previous standby_entered at least 45 min before); it ends when the machine becomes ready as the app shows it (a live sample with state 10, no steam, no descaling and |currentTemp - targetTemp| <= display.blinking.delta, default 0.5, right after a sample that was not), or with a ready event, at most 40 min after waking and without a shot in between. Live values only come while someone watches: only a heat-up seen from its beginning counts (samples from at most 60 s after waking, or still 10 °C or more below the target). Without a viewer the API reads it from the machine's 20-minute history (timeseries.get, job heatup.history about 15 min after a cold start's waking and, if not ready yet, about 30 min): the first sample after waking within the band that follows one that was not, by uptime of the same boot. Median of the last 5 cold ones with 60-1800 s, across the ownership chain. Members of the machine only (AD-35)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/shots",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-shots",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "History newest first without curves (FR-27); query before=<cursor from next>, limit 1..50 (default 20). Filters (concept beans-and-shot-history §3.1), each an extra condition of the keyset query: bean=<beanId>|none, from=<ms>, to=<ms> (sort time, to exclusive), rating=<0..3>[,...] (0 = not rated), source=switch|app, note=1, channeling=1, tag=<taste tag>. Members of the machine only (AD-35)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/shots/summary",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-shot-summary",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "Key figures of the history with the same filters as GET .../shots: count, mean brew time without pre-infusion, mean weight, mean ratio."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/shots/:shotId",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-shot",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "One shot with its curve."
    },
    {
      "method": "PATCH",
      "path": "/api/machines/:machineId/shots/:shotId",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-shot-update-request",
      "responses": {
        "200": "http-shot",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Rating and note (cloud-owned, AD-7, AD-44); a rating also goes to the machine as shot.rate while the shot is still there. ifRev mismatch: 409 rev_conflict."
    },
    {
      "method": "DELETE",
      "path": "/api/machines/:machineId/shots/:shotId",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "Tombstone (AD-8): a later delivery does not bring it back; shot.delete to the machine while it is there; clears the reference if it was one."
    },
    {
      "method": "PUT",
      "path": "/api/machines/:machineId/beans/:beanId/reference",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-reference-request",
      "responses": {
        "200": "http-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Set or clear the reference of a bean (concept beans-and-shot-history §3.1): shotId must be a shot of this bean (else 404). Goes to the bean's row of the current period (an ended period's rows stay). Is the bean the current one, the API sends it to the machine (shot.reference); the machine's copy is always the reference of the current bean."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/reference",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-reference",
        "401": "http-error",
        "403": "http-error"
      }
    },
    {
      "method": "PUT",
      "path": "/api/machines/:machineId/reference",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-reference-request",
      "responses": {
        "200": "http-reference",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "Set or clear the reference (AD-7); the API sends shot.reference to the machine (key, or the whole shot in parts if it is no longer there) and again after a reconnect if state/ref differs."
    },
    {
      "method": "GET",
      "path": "/api/account/claude",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-claude-account",
        "401": "http-error"
      },
      "note": "The account's Claude support (Dominik 19.10.2026: key per account, stored by Brewcore): whether a key is set (last four characters, when), model and effort. The key is never returned."
    },
    {
      "method": "PATCH",
      "path": "/api/account/claude",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-settings-request",
      "responses": {
        "200": "http-claude-account",
        "400": "http-error",
        "401": "http-error"
      },
      "note": "Model and effort of the account's Claude requests, asking automatically after a sour or bitter rating, the dismissed setup line."
    },
    {
      "method": "PUT",
      "path": "/api/account/claude/key",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-key-request",
      "responses": {
        "200": "http-claude-account",
        "400": "http-error",
        "401": "http-error",
        "402": "http-error",
        "429": "http-error",
        "503": "http-error"
      },
      "note": "Set or replace the key: checked once with a cheap request to Anthropic (claude_key_invalid, claude_credit, claude_unavailable), then kept sealed (AES-256-GCM, key from AUTH_SECRET with its own HKDF info, bound to the account). Never returned, never logged."
    },
    {
      "method": "DELETE",
      "path": "/api/account/claude/key",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-claude-account",
        "401": "http-error"
      },
      "note": "Removes the key. Conversations and the grinder stay until the shot or the account is deleted."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/claude/grinder",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-claude-grinder",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "The machine's grinder (brew.grinder) and what Claude found out about it for this account. Members of the machine only (AD-35)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/claude/grinder",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-grinder-request",
      "responses": {
        "200": "http-claude-grinder",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "409": "http-error",
        "429": "http-error",
        "502": "http-error",
        "503": "http-error"
      },
      "note": "Looks the grinder up with the account's key (Anthropic web search, at most 3 searches). Blocks until Claude answered (at most CLAUDE_TIMEOUT_MS)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/shots/:shotId/claude",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-claude-thread",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "The account's conversation with Claude about the shot (empty without one)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/shots/:shotId/claude/suggest",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-ask-request",
      "responses": {
        "200": "http-claude-thread",
        "400": "http-error",
        "401": "http-error",
        "402": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error",
        "422": "http-error",
        "429": "http-error",
        "502": "http-error",
        "503": "http-error"
      },
      "note": "A new suggestion with the account's key, server-side: the API builds the prompt from Postgres (bean, bags, recipe versions, recent shots of the bean, reference, curve) and checks the proposed changes (FR-31). Blocks until Claude answered; claude_no_key (409), claude_key_invalid, claude_credit, claude_model, claude_rate_limited, claude_refused, claude_failed, claude_unavailable, limit (per account, retryAfter)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/shots/:shotId/claude/chat",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-chat-request",
      "responses": {
        "200": "http-claude-thread",
        "400": "http-error",
        "401": "http-error",
        "402": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error",
        "422": "http-error",
        "429": "http-error",
        "502": "http-error",
        "503": "http-error"
      },
      "note": "The next message of the conversation; the answer may propose settings (also the pre-infusion). Errors as for suggest; the user's message is kept only with an answer."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/shots/:shotId/claude/applied",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-applied-request",
      "responses": {
        "200": "http-claude-thread",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "Marks the proposal of a message adopted (after its set command was confirmed), or offered again after an undo (applied false)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/beans",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-beans",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "The bean library of the machine (variant B, 19.10.2026): every bean ever seen in state/beans or a shot, or created in the app, archived ones too; newest recipe version and active bag each. Members of the machine only (AD-35)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/beans/:beanId",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-bean",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "One bean with its name history, every recipe version and every bag."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/beans/:beanId/claude",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-claude-bean",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "What Claude found out about the bean for this account (25.10.2026, board \"Eine Bohne\"). Members of the machine only (AD-35)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/beans/:beanId/claude",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-claude-bean-request",
      "responses": {
        "200": "http-claude-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "429": "http-error",
        "502": "http-error",
        "503": "http-error"
      },
      "note": "Looks the bean up with the account's key (Anthropic web search, at most 3 searches; name, roaster, origin and process as the question). Also once by itself with the first suggestion for a shot of the bean. Blocks until Claude answered (at most CLAUDE_TIMEOUT_MS)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/beans",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-bean-create-request",
      "responses": {
        "201": "http-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "A bean created in the app (cloud only until chosen); first recipe version from the current settings or another bean; a roast day starts its first bag. 409 bean_exists."
    },
    {
      "method": "PATCH",
      "path": "/api/machines/:machineId/beans/:beanId",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-bean-update-request",
      "responses": {
        "200": "http-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Master data, name (a bean on the machine: bean.rename first, the quick choice follows; machine offline: 409 offline), archive (frees its place with bean.delete; the current bean: 409 bean_in_use). 409 rev_conflict, bean_exists."
    },
    {
      "method": "DELETE",
      "path": "/api/machines/:machineId/beans/:beanId",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Only a bean without shots (409 bean_has_shots: archive it), never the current one (409 bean_in_use)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/beans/:beanId/bags",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-bag-request",
      "responses": {
        "201": "http-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "A new bag, the active one from now on; brings an archived bean back. Its roast day goes to the machine (bean.roast) when the bean is there (409 offline)."
    },
    {
      "method": "PATCH",
      "path": "/api/machines/:machineId/beans/:beanId/bags/:bagId",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-bag-request",
      "responses": {
        "200": "http-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Dates, weight, note, emptied; the active bag's roast day of a bean on the machine goes to it first. 409 rev_conflict, offline."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/beans/:beanId/recipes",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-recipe-request",
      "responses": {
        "201": "http-bean",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "A recipe version of a bean that is not the current one (source app); the current bean's recipe changes with set commands (409 bean_in_use)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/beans/:beanId/select",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Cloud operation \"Bohne wählen\": a bean in a slot (or one whose recipe is the current settings) with set brew.beans; any other with bean.restore first (owner with a fresh login: 403 owner_only, 401 fresh_login) until bean.put. Waits for the machine: 409 offline, no_response or its reason."
    },
    {
      "method": "POST",
      "path": "/api/invitations",
      "auth": "operator",
      "origin": true,
      "by": "api",
      "request": "http-invitation-create-request",
      "responses": {
        "201": "http-invitation",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error"
      }
    },
    {
      "method": "GET",
      "path": "/api/invitations",
      "auth": "operator",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-invitations",
        "401": "http-error",
        "403": "http-error"
      }
    },
    {
      "method": "DELETE",
      "path": "/api/invitations/:id",
      "auth": "operator",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      }
    },
    {
      "method": "GET",
      "path": "/api/ops/session",
      "auth": "operator",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-ops-session",
        "401": "http-error",
        "403": "http-error"
      }
    },
    {
      "method": "POST",
      "path": "/api/auth/email-code/start",
      "auth": "none",
      "origin": true,
      "by": "api",
      "request": "http-email-code-start-request",
      "responses": {
        "202": "http-email-code-start-response",
        "400": "http-error",
        "403": "http-error",
        "429": "http-error"
      },
      "note": "Sets the binding cookie __Host-bc_login (HttpOnly, Secure, SameSite=Strict, 15 min)."
    },
    {
      "method": "POST",
      "path": "/api/auth/email-code/verify",
      "auth": "none",
      "origin": true,
      "by": "api",
      "request": "http-email-code-verify-request",
      "responses": {
        "200": "http-auth-session",
        "400": "http-error",
        "403": "http-error",
        "429": "http-error"
      },
      "note": "Needs the binding cookie of the browser that requested the code; sets __Host-bc_session."
    },
    {
      "method": "GET",
      "path": "/api/auth/callback/google",
      "auth": "none",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "302": null
      },
      "note": "Google redirects here (code, state, iss). Success: redirect to next with the session cookie; failure: /login?error=<code>."
    },
    {
      "method": "GET",
      "path": "/api/auth/passkey/generate-register-options",
      "auth": "operator-fresh",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": null,
        "401": "http-error",
        "403": "http-error"
      },
      "note": "WebAuthn PublicKeyCredentialCreationOptionsJSON (the format @better-auth/passkey used before). Only operators with a fresh session."
    },
    {
      "method": "POST",
      "path": "/api/auth/passkey/verify-registration",
      "auth": "operator-fresh",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "200": null,
        "401": "http-error",
        "403": "http-error"
      },
      "note": "Pass-through: { response: RegistrationResponseJSON, name? }."
    },
    {
      "method": "GET",
      "path": "/api/auth/passkey/generate-authenticate-options",
      "auth": "none",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": null
      },
      "note": "Pass-through: PublicKeyCredentialRequestOptionsJSON."
    },
    {
      "method": "POST",
      "path": "/api/auth/passkey/verify-authentication",
      "auth": "none",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "200": null,
        "400": "http-error",
        "401": "http-error"
      },
      "note": "Pass-through: { response: AuthenticationResponseJSON }; creates an operator session (12 h, no sliding)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/diag",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": "http-diag-request",
      "responses": {
        "200": "http-diag",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "409": "http-error"
      },
      "note": "W19 'Protokoll anzeigen' (FR-24, owner and members): sends diag.log or diag.crash to the machine as the user and waits for the xfer document (at most about 35 s). One at a time per machine (409 pending); machine not connected 409 offline, no answer 409 no_response, refused 409 with its reason."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/recovery",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-recovery",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "FR-52 (Dominik 19.10.2026: the cloud is the backup): the last known settings offered once after a data loss or when a coupling continues an earlier one; 404 when nothing is offered. Owner and members (members see the note, the owner decides)."
    },
    {
      "method": "POST",
      "path": "/api/machines/:machineId/recovery",
      "auth": "fresh",
      "origin": true,
      "by": "api",
      "request": "http-recovery-request",
      "responses": {
        "200": "http-recovery-result",
        "400": "http-error",
        "401": "http-error",
        "403": "http-error",
        "404": "http-error",
        "409": "http-error"
      },
      "note": "Takes the last known state over (cloud operation settings.restore, protection S): owner only (403 owner_only), fresh login (401 fresh_login); every S value among params in confirmed (400 confirm_required, detail = the param); one set per state group as the owner; machine not connected 409 offline before anything is sent. Closes the offer once everything went through."
    },
    {
      "method": "DELETE",
      "path": "/api/machines/:machineId/recovery",
      "auth": "session",
      "origin": true,
      "by": "api",
      "request": null,
      "responses": {
        "204": null,
        "401": "http-error",
        "403": "http-error",
        "404": "http-error"
      },
      "note": "\"Nein, so lassen\": the owner keeps the machine's settings; the offer closes for everyone (owner only, 403 owner_only)."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/export",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": "http-export",
        "401": "http-error",
        "403": "http-error"
      },
      "note": "\"Daten exportieren\" (FR-3): the machine's whole cloud history with curves, beans, reference, care counters and settings as JSON, to use the data elsewhere (no backup: the cloud keeps it anyway); Content-Disposition attachment. Owner and members."
    },
    {
      "method": "GET",
      "path": "/api/machines/:machineId/export/shots.csv",
      "auth": "session",
      "origin": false,
      "by": "api",
      "request": null,
      "responses": {
        "200": null,
        "401": "http-error",
        "403": "http-error"
      },
      "note": "The shots of the export as CSV (text/csv, UTF-8 with BOM, ';' and decimal comma for lang=de, ',' and point otherwise; query lang=de|en)."
    }
  ]
};

/** Names of the message schemas (each has a precompiled validator). */
export const MESSAGE_SCHEMAS = [
  "http-auth-providers",
  "http-auth-session",
  "http-bag-request",
  "http-bean-create-request",
  "http-bean-update-request",
  "http-bean",
  "http-beans",
  "http-claude-account",
  "http-claude-applied-request",
  "http-claude-ask-request",
  "http-claude-bean-request",
  "http-claude-bean",
  "http-claude-chat-request",
  "http-claude-grinder-request",
  "http-claude-grinder",
  "http-claude-key-request",
  "http-claude-settings-request",
  "http-claude-thread",
  "http-diag-request",
  "http-diag",
  "http-email-code-start-request",
  "http-email-code-start-response",
  "http-email-code-verify-request",
  "http-error",
  "http-export",
  "http-google-start-request",
  "http-google-start-response",
  "http-heatup-response",
  "http-invitation-create-request",
  "http-invitation",
  "http-invitations",
  "http-machines",
  "http-me",
  "http-ops-session",
  "http-pairing-confirm-request",
  "http-pairing-confirm-response",
  "http-pairing-lookup-request",
  "http-pairing-lookup-response",
  "http-recipe-request",
  "http-recovery-request",
  "http-recovery-result",
  "http-recovery",
  "http-reference-request",
  "http-reference",
  "http-sessions",
  "http-shot-summary",
  "http-shot-update-request",
  "http-shot",
  "http-shots",
  "http-unpair-response",
  "ws-ack",
  "ws-bean-update",
  "ws-client",
  "ws-cmd",
  "ws-conn",
  "ws-error",
  "ws-event",
  "ws-flags",
  "ws-hello",
  "ws-history",
  "ws-live",
  "ws-profile",
  "ws-reference",
  "ws-revoked",
  "ws-server",
  "ws-shot-update",
  "ws-shot",
  "ws-snapshot",
  "ws-state",
  "ws-sub",
  "ws-unsub",
  "ws-welcome"
] as const;

export type MessageSchemaName = (typeof MESSAGE_SCHEMAS)[number];
